module.exports = __webpack_public_path__ + "static/media/image_placeholder.39747e4f.svg";